import { useMutation } from '@tanstack/react-query';
import { bffResendOtp } from '../api/client';

export const useResendOTP = () => {
    const { mutateAsync: resendOTP } = useMutation({
        mutationFn: (refId: string) => bffResendOtp({ refId }),
    });
    return resendOTP;
}